import { css } from "@emotion/react";
import type { ExactTheme as Theme } from "src/lib/emotion/theme.ts";

const SCROLLBAR_SIZE = 10;

const root = css`
  overflow: hidden;
  height: 100%;
`;

const viewport = css`
  width: 100%;
  height: 100%;
  border-radius: inherit;
  & > div[style] {
    height: 100%;
    display: block !important; // https://github.com/radix-ui/primitives/issues/926
  }
`;

const scrollbar = css`
  display: flex;
  // ensures no selection
  user-select: none;
  // disable browser handling of all panning and zooming gestures on touch devices
  touch-action: none;
  padding: 2px;

  &[data-orientation="vertical"] {
    width: ${SCROLLBAR_SIZE}px;
  }

  &[data-orientation="horizontal"] {
    flex-direction: column;
    height: ${SCROLLBAR_SIZE}px;
  }
`;

const thumb = (theme: Theme) => css`
  flex: 1;
  background: ${theme.colorsV2.grey[300]};
  border-radius: ${SCROLLBAR_SIZE}px;
  // increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html
  position: relative;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: 44px;
    min-height: 44px;
  }
`;

const corner = (theme: Theme) => css`
  background: "transparent";
`;

export { root, viewport, scrollbar, corner, thumb };
